import { ErrorApi } from "@core/modeles/model.ts";
import { ProfileService } from "@modules/dashbord/dashbord.service.ts";
import { createAsyncThunk } from "@reduxjs/toolkit";

const dashboardService = new ProfileService();

interface FilterDashboardExtern {
    dateDebut?: string;
    dateFin?: string;
    typePlainte?: number;
    region?: number;
    district?: number;
    commune?: number;
    fokontany?: number;
}

export const getExternStat = createAsyncThunk(
  "dashboard/externeStat",
    async (filter: FilterDashboardExtern) => {
        const externeDashboard = await dashboardService.getExternStat(filter);
        return externeDashboard;
    }
);

export const importFileExternalAgent = createAsyncThunk(
    "dashboard/importFileExternalAgent",
    async ({
      file,
      onSuccess,
      onError,
      onProgress,
    }: {
      file: File;
      onSuccess?: (a: any) => void;
      onError?: (a: any) => void;
      onProgress?: (percent: number) => void;
    }, {rejectWithValue}) => {
      try {
        const response = await dashboardService.importFileExternalAgent(file, (event) => {
          if (event.total) {
            const percentCompleted = Math.round((event.loaded * 100) / event.total);
            if (onProgress) onProgress(percentCompleted);
          }
        });
        if (onSuccess) onSuccess(response);
        return response;
      } catch (error: any) {
        if (onError) onError(error as ErrorApi);
      return rejectWithValue(error.response?.data || error.message || "An unknown error occurred");
      }
    }
);

export const checkFileExists = createAsyncThunk(
    "dashboard/checkFileExists",
    async ({
      file,
      onSuccess,
      onError,
      onProgress,
    }: {
      file: File;
      onSuccess?: (a: any) => void;
      onError?: (a: any) => void;
      onProgress?: (percent: number) => void;
    }, {rejectWithValue}) => {
      try {
        const response = await dashboardService.checkFileExists(file, (event) => {
          console.log("Progress event:", event);
          if (event.total) {
            const percentCompleted = Math.round((event.loaded * 100) / event.total);
            if (onProgress) onProgress(percentCompleted);
          }
        });
        if (onSuccess) onSuccess(response);
        return response;
      } catch (error: any) {
        if (onError) onError(error as ErrorApi);
      return rejectWithValue(error.response?.data || error.message || "An unknown error occurred");
      }
    }
);

export const getFileExternAgent = createAsyncThunk(
  "dashboard/fileExternAgent",
  async (filter: FilterDashboardExtern, { rejectWithValue }) => {
      try {
        const fileBlob = await dashboardService.getFileExternAgent(filter);
        return fileBlob;
      } catch (error) {
        return rejectWithValue(error);
      }
    }
)
  